import { useMemo } from 'react'

import { Offer } from '@wwt/entities/search-response'

export const useOfferCardHotelNameWithRating = (offer: Offer) => {
	return useMemo(
		() => ({
			hotelName: offer.hotelStatic.name,
			stars: offer.hotelStatic.stars,
			hotelType: offer.hotelStatic.accommodationType
		}),
		[offer]
	)
}
